import MaintenanceList from './MaintenanceList'

export default MaintenanceList;


